exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heart-wrap[data-v-4a441361] {\n  display: flex;\n  margin-left: auto;\n}\n.grid .likes[data-v-4a441361] {\n  margin-right: 15px;\n}\n.dark .likes[data-v-4a441361] {\n  color: white;\n}\n.dark .likes span[data-v-4a441361] {\n  color: #3b3e44;\n}\na.likes[data-v-4a441361]:hover {\n  color: #3399ff;\n}\na.likes:hover span[data-v-4a441361] {\n  color: white;\n}\n.likes[data-v-4a441361] {\n  margin-right: 10px;\n  color: #3b3e44;\n}\n.likes span[data-v-4a441361] {\n  position: absolute;\n  margin-top: 5px;\n  text-align: center;\n  width: 30px;\n  font-size: 10px;\n  color: white;\n}", ""]);

// exports
